import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "@/page/layout";
Vue.use(VueRouter);
/**
 * isAuth:是否需要授权登录   false：不需要
 * noBar: 是否显示底部  true：不显示
 */
const routes = [
  {
    path: "/",
    redirect: "/home",
  },
  // {
  //   path: '/index',
  //   name: 'index',
  //   meta: {
  //     title: '首页'
  //   },
  //   component: () => import( /* webpackChunkName: "Home" */ '@/views/home/index')
  // },
  {
    path: "/home",
    name: "home",
    component: Layout,
    redirect: "/home/index",
    children: [
      {
        path: "index",
        name: "homeIndex",
        meta: {
          title: "收费项目",
          keepAlive: true,
          isAuth: false
        },
        component: () => import("@/views/home/index"),
      },
      {
        path: "/goodsDetail",
        name: "goodsDetail",
        meta: {
          title: "商品详情",
          noBar: true,
        },
        component: () => import("@/views/shoppingCart/detail"),
      },
      {
        path: "/orderConfirm",
        name: "orderConfirm",
        meta: {
          title: "订单确认",
        },
        component: () => import("@/views/order/orderConfirm"),
      },
      {
        path: "/orderDetail",
        name: "orderDetail",
        meta: {
          title: "订单详情",
        },
        component: () => import("@/views/order/detail"),
      },
    ],
  },
  {
    path: "/shoppingCart",
    name: "shoppingCart",
    component: Layout,
    redirect: "/shoppingCart/index",
    children: [
      {
        path: "index",
        name: "shoppingCartIndex",
        meta: {
          title: "购物车",
          // keepAlive: true,
        },
        component: () => import("@/views/shoppingCart/index"),
      },
    ],
  },
  
 
  {
    path: "/user",
    name: "user",
    component: Layout,
    redirect: "/user/index",
    children: [
      {
        path: "index",
        name: "userIndex",
        meta: {
          title: "个人中心",
        },
        component: () => import("@/views/user/index"),
      },
      {
        path: "accountSetting",
        name: "accountSetting",
        meta: {
          title: "账号设置",
        },
        component: () => import("@/views/user/accountSetting/index"),
      },
      {
        path: "binding",
        name: "binding",
        meta: {
          title: "身份绑定",
        },
        component: () => import("@/views/user/binding/index"),
      },
      {
        path: "feedback",
        name: "feedback",
        meta: {
          title: "帮助与反馈",
        },
        component: () => import("@/views/user/feedback/index"),
      },
      {
        path: "afterSales",
        name: "afterSales",
        meta: {
          title: "帮助与反馈",
        },
        component: () => import("@/views/user/feedback/afterSales"),
      },
      {
        path: "myOrders",
        name: "myOrders",
        meta: {
          title: "我的订单",
        },
        component: () => import("@/views/user/myOrders/index.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    meta: {
      title: "登录中，请稍等",
    },
    component: () => import("@/views/login"),
  },
];

const router = new VueRouter({
  // mode: "hash",
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
